import styled from 'styled-components';

const StyledImage = styled.img`
	user-select: none;
	pointer-events: none;
	object-fit: contain;
`;

const StyledMaskImage = styled.div<{
	$icon: string;
	$size: number;
	$color?: string;
}>`
	width: ${({ $size }) => $size}px;
	height: ${({ $size }) => $size}px;
	mask-image: url(${({ $icon }) => $icon});
	mask-repeat: no-repeat;
	mask-position: center;
	mask-size: contain;
	-webkit-mask-image: url(${({ $icon }) => $icon});
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	-webkit-mask-size: contain;
	transition: background-color 0.3s ease;
	background-color: ${({ $color }) => $color || '#ffffff'};
`;

export { StyledImage, StyledMaskImage };
